export default __webpack_public_path__ + "static/media/WellTrajectoryLogo.46864f1a.png";